import { Box, CloseIcon, IconButton, Theme, Tooltip, Typography, useTheme } from '@freighthub/silhouette-core'
import { FC } from 'react'

import { Avatar } from './Avatar'
import { IAvatarProps } from './IAvatarProps'

export const subscriptionAvatarTestIds = {
  avatar: 'subscription-avatar',
  closeIcon: 'subscription-close-icon',
}

const getStyles = (theme: Theme) => ({
  root: {
    position: 'relative',
    marginRight: theme.spacing(0.5),
    '&:hover button': {
      display: 'block',
    },
  },
  close: {
    position: 'absolute',
    cursor: 'pointer',
    top: theme.spacing(-1),
    right: theme.spacing(-1),
    zIndex: 9999,
    display: 'none',
  },
  closeIcon: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.action.active,
    borderRadius: '50%',
    padding: theme.spacing(0.25),
  },
  nameContainer: {
    display: 'inline-block',
    width: 60,
    textAlign: 'center',
    marginTop: theme.spacing(0.6),
  },
  name: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
})

interface ISubscriptionAvatarProps extends IAvatarProps {
  onClick?: () => void
  disabled: boolean
  hoverText?: string
  subscriberName?: string
  displayName: boolean
}

export const SubscriptionAvatar: FC<ISubscriptionAvatarProps> = ({
  avatar,
  avatarType,
  disabled,
  hoverText,
  subscriberName,
  displayName,
  className,
  onClick,
  userType,
}) => {
  const styles = getStyles(useTheme())
  const [firstName, lastName] = subscriberName ? subscriberName.split(' ') : ['', '']
  return (
    <Tooltip title={hoverText || ''}>
      <Box
        data-testid={subscriptionAvatarTestIds.avatar}
        sx={styles.root}
        className={className}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {!disabled && (
          <IconButton
            data-testid={subscriptionAvatarTestIds.closeIcon}
            onClick={onClick}
            sx={styles.close}
            size="small"
          >
            <CloseIcon sx={styles.closeIcon} fontSize="small" />
          </IconButton>
        )}
        <Avatar avatar={avatar} avatarType={avatarType} userType={userType} size="large" fullName={subscriberName} />
        {displayName && (
          <Box sx={styles.nameContainer}>
            <Typography variant="body3" sx={styles.name} component="p">
              {firstName}
            </Typography>
            <Typography variant="body3" sx={styles.name} component="p">
              {lastName}
            </Typography>
          </Box>
        )}
      </Box>
    </Tooltip>
  )
}
